import { createPage } from '../../shared/create-page'

// ============================================
// DESCOBERTA DE CONTEÚDO
// ============================================

export const HomePage = createPage(() => import('@pages/user/home/home-page'))

export const SearchPage = createPage(() => import('@pages/user/search/search-page'))

export const FavoritesPage = createPage(() => import('@pages/user/favorites/favorites-page'))

export const CategorySearchPage = createPage(
  () => import('@pages/user/search/category-search-page')
)

export const CategoryGroupSearchPage = createPage(
  () => import('@pages/user/search/category-group-search-page')
)

export const SkillSearchPage = createPage(() => import('@pages/user/search/skill-search-page'))

export const InstitutionSearchPartnerPage = createPage(
  () => import('@pages/user/search/institution-search-page')
)

export const InstitutionsListPartnersPage = createPage(
  () => import('@pages/user/search/institutions-search-page')
)

export const ContentPage = createPage(
  () => import('@pages/user/content/content-details/content-page')
)

export const ContentEnrollmentPage = createPage(
  () => import('@pages/user/content/content-enrollment/content-enrollment-page')
)

export const ContentCompletePage = createPage(
  () => import('@pages/user/content/content-complete/content-complete-page')
)

export const ScholarshipRenewalInfoPage = createPage(
  () => import('@pages/user/content/content-enrollment/scholarship-renewal-info-page')
)

export const ContentFitScorePage = createPage(
  () => import('@pages/user/content/content-fit-score/content-fit-score-page')
)

export const ContentUnsubscribePage = createPage(
  () => import('@pages/user/content/content-unsubscribe/content-unsubscribe-page')
)

// ============================================
// CB ÚNICO
// ============================================

export const CbUnicoStartPage = createPage(() => import('@pages/user/cbu/cb-unico-start-page'))

// ============================================
// AVALIAÇÃO DE PERFIL
// ============================================

export const ProfileAssessmentGetStartedPage = createPage(
  () => import('@pages/user/profile-assessment/get-started-page')
)

export const ProfileAssessmentCallbackPage = createPage(
  () => import('@pages/user/profile-assessment/profile-assessment-callback-page')
)

export const ProfileAssessmentInProgressPage = createPage(
  () => import('@pages/user/profile-assessment/profile-assessment-in-progress-page')
)

// ============================================
// DADOS E PERFIL DO USUÁRIO
// ============================================

export const UserProfilePage = createPage(
  () => import('@pages/user/user-profile/user-profile-page')
)

export const UserInterestAreasSkillsPage = createPage(
  () => import('@pages/user/user-interest-areas-skills/user-interest-areas-skills-page')
)

export const UserSettingsPage = createPage(
  () => import('@pages/user/user-settings/user-settings-page')
)

export const UserSpacePage = createPage(() => import('@pages/user/user-space/user-space-page'))

export const UserLearningPreferencesPage = createPage(
  () => import('@pages/user/user-learning-preferences/user-learning-preferences-page')
)

export const UserEnrollmentsPage = createPage(
  () => import('@pages/user/user-enrollments/user-enrollments-page')
)

export const UserEnrollmentDetailPage = createPage(
  () => import('@pages/user/user-enrollment-detail/user-enrollment-detail-page')
)

export const UserEnrollmentEngagementPage = createPage(
  () => import('@pages/user/user-enrollment-engagement/user-enrollment-engagement-page')
)

export const UserEnrollmentScholarshipRenewalPage = createPage(
  () =>
    import(
      '@pages/user/user-enrollment-scholarship-renewal/user-enrollment-scholarship-renewal-page'
    )
)

export const ContactVerificationPage = createPage(
  () => import('@pages/user/contact-verification/contact-verification-page')
)

// ============================================
// ONBOARDING
// ============================================

export const OnboardingWelcomePage = createPage(
  () => import('@pages/user/onboarding/onboarding-welcome-page')
)

export const OnboardingLayout = createPage(
  () => import('@presentation/components/ui/layout/onboarding-layout')
)

export const OnboardingPersonalDataPage = createPage(
  () => import('@pages/user/onboarding/onboarding-personal-data-page')
)

export const OnboardingProfessionalTrajectoryPage = createPage(
  () => import('@pages/user/onboarding/onboarding-professional-trajectory-page')
)

export const Onboarding3Page = createPage(() => import('@pages/user/onboarding/onboarding-3-page'))

export const Onboarding4Page = createPage(() => import('@pages/user/onboarding/onboarding-4-page'))

export const OnboardingSecurityPage = createPage(
  () => import('@pages/user/onboarding/onboarding-security-page')
)

export const OnboardingCompletedPage = createPage(
  () => import('@pages/user/onboarding/onboarding-completed-page')
)

// ============================================
// SOLICITAÇÃO DE DEPENDENTE
// ============================================

export const DependentRequestPage = createPage(
  () => import('@pages/user/dependent-request/dependent-request-page')
)

export const DependentRequestCatalogPage = createPage(
  () => import('@pages/user/dependent-request/dependent-request-catalog-page')
)

export const DependentContentPage = createPage(
  () => import('@pages/user/content/content-details/dependent-content-page')
)

// ============================================
// SOLICITAÇÃO DE UPGRADE
// ============================================

export const UpgradeRequestPage = createPage(
  () => import('@pages/user/upgrade-request/upgrade-request-page')
)

// ============================================
// REEMBOLSO
// ============================================

export const RefundProgramListPage = createPage(
  () => import('@pages/user/refund/refund-program-list-page')
)

export const RefundRequestPage = createPage(
  () => import('@pages/user/refund/request/refund-request-page')
)

// ============================================
// SEM PLANO
// ============================================

export const NoPlanPage = createPage(() => import('@pages/user/no-plan/no-plan-page'))
